<template>
  <div class="combined-page">
    <div class="search-bar">
      <button class="back-button" @click="goBack">返回</button>
      <input type="text" placeholder="搜索房型" v-model="searchQuery" />
      <button @click="performSearch">搜索</button>
    </div>

    <div class="product-list" @scroll="handleScroll">
      <div v-if="!products && !isLoading" class="empty-state">
      暂无数据
    </div>

      <div class="product-item" v-for="(product, index) in products" :key="index">
        <img :src="product.houseImageUrl" :alt="product.houseName" class="product-image" @click="gotoDetail(product.houseId)"/>
        <div class="product-name">{{ product.houseName }}</div>
      </div>
    </div>
  </div>


  <!-- <div class="product-list" @scroll="handleScroll">
      <div class="product-item" v-for="(product, index) in products" :key="index">
        <img :src="product.houseImageUrl" :alt="product.houseName" class="product-image" @click="gotoDetail(product.houseId)"/>
        <div class="product-name">{{ product.houseName }}</div>
      </div>
    </div> -->
</template>
    
    <script setup>
import { ref, getCurrentInstance,onMounted} from "vue";
import { useRouter,useRoute } from "vue-router"; // 导入 useRoute 和 useRouter
import { debounce } from "lodash-es"; // 引入lodash的debounce函数
const currentPage = ref(1);
const pageSize = ref(10);
const totalPage = ref(0);
const isLoading = ref(false);
const searchQuery = ref("");
const route = useRoute(); // 获取当前路由信息

const { proxy } = getCurrentInstance();
const router = useRouter(); // 获取当前路由信息

const products = ref([]);

const selectedHouseName = ref('');


const performSearch = () => {
  // 这里可以添加搜索逻辑
  queryHouseBySearch(
    searchQuery.value,
    1,
    '',
    'asc'
  );
};

const queryHouseBySearch = async (value, page = 1, sortType, sortValue) => {
  selectedHouseName.value = value;
  if (isLoading.value) return; // 如果正在加载，则不重复请求
  isLoading.value = true;
  const url = "/house/queryHouse";
  proxy.$tools
    .request(url, {
      reqBody: {
        houseName: value,
        page: page,
        pageSize: pageSize.value,
        sortType: sortType,
        sortValue: sortValue,
      },
    })
    .then((response) => {
      if (page === 1) {
        products.value = response.data.rspBody.houseList; // 如果是第一页，则直接赋值
        totalPage.value = response.data.rspBody.totalPage;
      } else {
        products.value = [
          ...products.value,
          ...response.data.rspBody.houseList,
        ]; // 否则，追加到列表中
        totalPage.value = response.data.rspBody.totalPage;
      }
      currentPage.value = page; // 更新当前页码
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      isLoading.value = false; // 请求结束，无论成功或失败
    });
};

const handleScroll = debounce(() => {
  const container = document.querySelector(".product-list");
  if (
    container.scrollTop + container.clientHeight >=
    container.scrollHeight - 100
  ) {
    if (currentPage.value < totalPage.value) {
      // 当滚动到底部时，加载下一页
      queryHouseBySearch(
        selectedHouseName.value,
        currentPage.value + 1,
        '',
        'asc'
      );
    }
  }
}, 200); // 使用防抖函数，200毫秒内多次触发只会执行一次

const gotoDetail = (id) => {
  router.push({ name: "HouseDetail", params: { houseId: id } }); // 使用 router.push 方法跳转到其他页面
};

// 同时处理：空字符串、纯空格、null、undefined
const isEmpty = (str) => {
  return !str?.trim() // 使用可选链防止null/undefined报错
}

const goBack = () => {
  router.go(-1) // 或使用 router.back()
  }


onMounted(() => {
  let houseName1 = route.query.houseName || '';// 获取传递的 id
  console.log("搜索房型："+houseName1);
  // 使用示例
  if (!isEmpty(houseName1)) {
   searchQuery.value = houseName1;
   queryHouseBySearch(
      searchQuery.value,
      1,
      '',
      'asc'
    );
  }
     
  });
</script>
    
<style scoped>
  .combined-page {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  padding-bottom: 68px;
  background: #f5f5f5;
}

.back-button {
  padding: 10px;  border: none;  background: #f0f0f0;  color: #666;  border-radius: 8px;
  min-width: 60px;}

.search-bar {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 8px;
}

.search-bar input {
  flex: 1;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 14px;
}

.search-bar button {
  padding: 10px 20px;
  border: none;
  background: #007bff;
  color: white;
  border-radius: 8px;
  margin-left: 8px;
  font-weight: 500;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;
  max-height: 75vh;
  overflow-y: auto;
}

.product-item {
  width: calc(50% - 6px);
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}

.product-item:hover {
  transform: translateY(-3px);
}

.product-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.product-name {
  padding: 12px;
  font-size: 13px;
  text-align: center;
  color: #444;
}

.empty-state {
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: #888;
  font-size: 14px;
}

@media (min-width: 768px) {
  .product-item {
    width: calc(33.333% - 8px);
  }
  
  .product-image {
    height: 200px;
  }
}
  </style>